import { useState, ChangeEvent, useCallback } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Textarea } from 'UIPackage/MainModule/components/Textarea';

import styles from './CancelKnmsModal.module.scss';

interface ICancelKnmsModalProps {
  visible?: boolean;
  knmsNumber: number;
  onApply: (commentText?: string) => void;
  onClose: () => void;
}

export const CancelKnmsModal = ({ visible, knmsNumber, onApply, onClose }: ICancelKnmsModalProps) => {
  const [commentTextareaValue, setCommentTextareaValue] = useState('');

  const handleCommentTextareaChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setCommentTextareaValue(e.target.value);
  }, []);

  const handleApplyButtonClick = useCallback(() => {
    onApply(commentTextareaValue);
  }, [commentTextareaValue, onApply]);

  const handleAfterClose = useCallback(() => setCommentTextareaValue(''), []);

  return (
    <Modal visible={visible} modalBodyClassName={styles.ModalBody} onClose={onClose} afterClose={handleAfterClose}>
      <ModalHeader title={`Аннулирование КНМ (${knmsNumber})`} sizeText="small" />
      <ModalBody size="content" border="bottom">
        <label className={styles.CommentTextareaLabel} htmlFor="cancel-knms-comment-input">
          Введите основание аннулирования
        </label>
        <Textarea
          className={styles.CommentTextarea}
          inputClassName={styles.CommentTextareaInput}
          id="cancel-knms-comment-input"
          value={commentTextareaValue}
          resize="vertical"
          autoHeight={false}
          onChange={handleCommentTextareaChange}
        />
      </ModalBody>
      <ModalActions>
        <Button text="Аннулировать" color="primary" size="medium" type="button" onClick={handleApplyButtonClick} />
        <Button text="Отменить" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
